














import { Component, Vue } from 'vue-property-decorator';
import HeaderTopBar from '@/views/layout/HeaderTopBar.vue';
import HeaderActionSection from '@/views/layout/HeaderActionSection.vue';
import HeaderBottomNavigation from '@/views/layout/HeaderBottomNavigation.vue';
import { getModule } from 'vuex-module-decorators';
import SearchBarStore from '@/stores/search/searchBar.store';
import SearchSuggestionDropdown from '@/views/search/SearchSuggestionDropdown.vue';
import { CmsStore } from '@/stores/cms.store';
import { EventKey } from '@/util/EventKey';

@Component({
  components: {
    SearchSuggestionDropdown,
    HeaderBottomNavigation,
    HeaderActionSection,
    HeaderTopBar,
  },
})
export default class Header extends Vue {
  private searchBarStore = getModule(SearchBarStore, this.$store);
  private cmsStore = getModule(CmsStore, this.$store);

  get showSearchSuggestions() {
    return this.searchBarStore.isSearchBarActive;
  }

  get duringCheckout() {
    return this.$route.matched.some((record) => record.meta.checkoutHeader);
  }

  get duringRegistration() {
    return this.$route.matched.some((record) => record.meta.isRegisterHeader);
  }

  public async mounted(): Promise<void> {
    this.$events.$on(EventKey.INITIAL_LANGUAGE, this.fetchHeaderIfNecessary);
    this.$events.$on(EventKey.LANGUAGE_CHANGE, this.fetchHeaderIfNecessary);
  }

  private async fetchHeaderIfNecessary(language: string): Promise<void> {
    await this.cmsStore.fetchHeaderIfNecessary(language);
  }
}
